export default "__VITE_ASSET__30aa5c40__"